import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private http: HttpClient) { }

  getNewTransactionId(orderTranscationId: string) {
    return this.http.get<string>(environment.PAYMENT_UI + '/epms/transaction/generate/' + orderTranscationId, {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      withCredentials: true
    }).toPromise();
  }
}
